import React, { useMemo } from 'react'
import { ResultDisplayProps } from '../../common'
import './ConversationTimeline.scss'
import { useConversationTimelineResult } from './hooks'
import classNames from 'classnames'
import { Button } from '../../../../../../../components/Button/Button'
import { SentimentTrendChart } from '../../../SentimentAnalysis/SentimentTrendChart'
import { useAppSelector } from '../../../../../../../store/hooks'
import { selectRoomSession } from '../../../../../../../store/meetingSummary/roomSession'
import { parseMetadata } from '../../../utils'
import { ParticipantSentiment, SentimentAnalysisMetadata } from '../../../SentimentAnalysis/model'
import { filterCloseTimelineItems } from './sentiment_helper'
import { useAccount } from '../../../../../../../common/useAccount'

export const ConversationTimelineCollapsed: React.FC<ResultDisplayProps> = ({ aiResult, collapsed, setCollapsed }) => {
  const { account } = useAccount({ refetchOnMountOrArgChange: false })
  const { displayMode, results, mostPopularResult } = useConversationTimelineResult(aiResult)
  const roomSession = useAppSelector(selectRoomSession)

  const sentimentAnalysis = useMemo(() => {
    if (!roomSession) {
      return null
    }

    const metadata = parseMetadata(roomSession.metadata) as SentimentAnalysisMetadata
    const participants = metadata?.sentimentAnalysis?.participants ?? null

    if (!participants) {
      return null
    }

    const timelineItems = (Object.values(participants) as ParticipantSentiment[])
      .flatMap((participant: ParticipantSentiment) => participant.timeline)
      .sort((a, b) => a.timestamp - b.timestamp)
    return filterCloseTimelineItems(timelineItems)
  }, [roomSession])

  if (displayMode === 'default') {
    return null
  }
  return (
    <>
      <div role='button' className='zocks-pr-1.75 zocks-pl-2.0' onClick={() => setCollapsed(!collapsed)}>
        <div className='d-flex flex-column gap-2'>
          <div className='d-flex justify-content-between conversation-timeline-collapsed-info-container zocks-p-2.5'>
            <div className='d-flex flex-column gap-2'>
              <div className='lead-extra-small'>Most Discussed Topic</div>
              <div>{mostPopularResult?.topic ?? '-'}</div>
              <h2>{mostPopularResult?.percentage ?? '-'}</h2>
            </div>

            <div className='align-self-center'>
              <Button variant='darkGhost' className='p-2 button-small'>
                Show more
              </Button>
            </div>
          </div>
          {account?.effectiveConfig.sentimentAnalysis && sentimentAnalysis && (
            <div className='mb-2 sentiment-analysis-chart'>
              <SentimentTrendChart timeline={sentimentAnalysis} width='100%' height='300px' />
            </div>
          )}
          <div className='conversation-timeline-collapsed-timeline-container d-flex gap-2'>
            {results.map((r) => {
              return (
                <div
                  key={r.topic}
                  className={classNames('conversation-timeline-percentage', {
                    'conversation-timeline-percentage-selected': r.topic === mostPopularResult?.topic,
                  })}
                  style={{ width: r.percentage }}
                ></div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}
